import React from "react";
import { formatCurrency } from "src/helpers";
import { classNames } from "src/helpers/classNames";

const PlanItems = ({ data = null }) => {
  return (
    <div className="relative flex w-full items-center gap-x-2">
      <div className="w-full space-y-1">
        <div className="flex items-center justify-between space-x-3">
          <p className="truncate font-semibold text-gray-700">{data?.name}</p>
        </div>
        <div className="flex items-center justify-between space-x-3">
          <div className="flex space-x-3">
            {data?.pricing?.rates?.map((price) => (
              <p
                key={price?._id}
                className="truncate text-xs text-gray-600">
                {formatCurrency(price?.amount - price?.discount_amount, data?.currency)}/{price?.interval}
              </p>
            ))}
          </div>
          <p className="flex-shrink-0 truncate text-xs">
            <span className={classNames("inline-block rounded-full  px-2 py-1 !leading-none ", data?.status ? "bg-green-100 text-green-600" : "bg-red-100 text-red-600")}>{data?.status ? "Active" : "Inactive"}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlanItems;
